import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "clearButton", "spinner"]
  static values = { delay: Number }

  connect() {
    this.submitTimeout = null
    this.loading = false
    this.lastSubmittedQuery = this.normalizedQuery
    this.toggleControls()
  }

  disconnect() {
    this.clearPendingSubmit()
  }

  handleInput() {
    this.toggleControls()
    this.scheduleSubmit()
  }

  clear() {
    if (!this.hasInputTarget) return

    this.inputTarget.value = ""
    this.toggleControls()
    this.submitNow()
    this.inputTarget.focus()
  }

  resetOnEscape(event) {
    if (this.normalizedQuery.length === 0) return

    event.preventDefault()
    this.clear()
  }

  cancelPendingSubmit() {
    this.clearPendingSubmit()
    this.normalizeInput()
    this.lastSubmittedQuery = this.normalizedQuery
    this.toggleControls()
  }

  startLoading() {
    this.loading = true
    this.toggleControls()
  }

  finishLoading() {
    this.loading = false
    this.toggleControls()
  }

  scheduleSubmit() {
    this.clearPendingSubmit();
    this.submitTimeout = window.setTimeout(() => this.submitNow(), this.delayValue || 500)
  }

  submitNow() {
    this.clearPendingSubmit()
    this.normalizeInput()
    this.toggleControls()

    if (this.normalizedQuery === this.lastSubmittedQuery) return

    this.lastSubmittedQuery = this.normalizedQuery
    this.element.requestSubmit()
  }

  clearPendingSubmit() {
    if (!this.submitTimeout) return

    window.clearTimeout(this.submitTimeout)
    this.submitTimeout = null
  }

  normalizeInput() {
    this.inputTarget.value = this.normalizedQuery
  }

  toggleControls() {
    if (this.hasClearButtonTarget) {
      this.clearButtonTarget.classList.toggle("hidden", this.loading || this.normalizedQuery.length === 0)
    }

    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.toggle("hidden", !this.loading)
    }
  }

  get normalizedQuery() {
    return this.hasInputTarget ? this.inputTarget.value : ""
  }
}